import { render, staticRenderFns } from "./ShowAmountTipDialog.vue?vue&type=template&id=8ae3df94&scoped=true"
import script from "./ShowAmountTipDialog.vue?vue&type=script&lang=ts"
export * from "./ShowAmountTipDialog.vue?vue&type=script&lang=ts"
import style0 from "./ShowAmountTipDialog.vue?vue&type=style&index=0&id=8ae3df94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae3df94",
  null
  
)

export default component.exports